import { PureComponent } from "react";
import { error } from "../Notifications/helper";

interface IMeta {
    touched: boolean;
    error: string;
    warning: string;
}

interface IProps {
    notification: string;
    input: any;
    placeholder?: string;
    type: string;
    meta: IMeta;
    id: string;
}

export default class TextInput extends PureComponent<IProps> {
    notified: boolean;

    render() {
        const { meta, type, placeholder, id } = this.props;
        const textTypes = ["text", "email", "password"];
        let controlClass = !!textTypes.find((x) => x === type) ? "form-control" : "form-check-input";
        if (meta.touched && meta.error) {
            controlClass += " input-validation-error";
        }

        if (meta.touched && meta.error && !this.notified && this.props.notification) {
            error(this.props.notification);
            this.notified = true;
        }

        return (
            <>
                <input {...this.props.input} id={id} className={controlClass} placeholder={placeholder} type={type} />
                {meta.touched &&
                    ((meta.error && <span className="error">{meta.error}</span>) ||
                        (meta.warning && <span className="warning">{meta.warning}</span>))}
            </>
        );
    }
}
